import * as rfps from './rfp.service';

export default class RfpMixesService {
  constructor(private $http) {
    'ngInject';
  }

  getCurrentMix(
    rfpId: number,
    offers: string,
    usePrimaryCrossReferences: boolean,
    useLockedAllocations: boolean
  ): ng.IPromise<rfps.Mix> {
    return this.$http.get(`/aptitude/api/rfps/${rfpId}/mixes/current`, {
      params: {
        offers,
        usePrimaryCrossReferences,
        useLockedAllocations
      }
    });
  }

  getBestMix(
    rfpId: number,
    offers: string,
    usePrimaryCrossReferences: boolean,
    useLockedAllocations: boolean
  ): ng.IPromise<rfps.Mix> {
    return this.$http.get(`/aptitude/api/rfps/${rfpId}/mixes/best`, {
      params: {
        offers,
        usePrimaryCrossReferences,
        useLockedAllocations
      }
    });
  }

  getOptimizedMix(
    rfpId: number,
    offers: string,
    duration: number,
    tierId: number,
    pricingType: string,
    usePrimaryCrossReferences: boolean,
    useLockedAllocations: boolean
  ): ng.IPromise<rfps.Mix> {
    return this.$http.get(`/aptitude/api/rfps/${rfpId}/mixes/optimized`, {
      params: {
        offers,
        duration,
        tierId,
        pricingType,
        usePrimaryCrossReferences,
        useLockedAllocations
      }
    });
  }

  getGroupPlan(
    rfpId: number,
    offers: string,
    usePrimaryCrossReferences: boolean
  ): ng.IPromise<rfps.Mix> {
    return this.$http.get(`/aptitude/api/rfps/${rfpId}/mixes/groupplan`, {
      params: {
        offers,
        usePrimaryCrossReferences
      }
    });
  }
}
